var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.configured)+"/"+_vm._s(_vm.points.length)+" "),_c('i',{staticClass:"fa fa-fw",class:_vm.icon == 'success' ? 'fa-check-circle text-success' : 'fa-exclamation-triangle text-danger'})])}
var staticRenderFns = []

export { render, staticRenderFns }